import Em from 'ember';
export default Em.Mixin.create({
  bold(action) {
    this._applyEntity('bold');
    return action;
  },
  italic(action) {
    this._applyEntity('italic');
    return action;
  },
  anchor(action) {
    this.syncCurrentBlockAndCheckpoint();
    this.get('composerState').anchor('');
    this.updateDomAndSelection();
    return action;
  },
  underline(action) {
    return action;
  },
  undo(action) {
    this.syncCurrentBlockIfNoRedoStack();
    this.get('composerState').undo();
    this.updateDomAndSelection();
    return action;
  },
  redo(action) {
    this.syncCurrentBlock();
    this.get('composerState').redo();
    this.updateDomAndSelection();
    return action;
  },
  deleteToStartOfLine(action) {
    this.syncCurrentBlock();
    if (!this.get('uiSelection').isRange() && this.get('composerState.selection.startPositionIndex') !== 0 && !this.get('uiSelection.domSelection').isImmediatelyBeforeBr()) {
      let currentSelection = this.getUiSelection();
      let startOfLineSelection = this.get('uiSelection.domSelection').getStartOfCurrentLine();
      if (startOfLineSelection) {
        this.get('composerState').setSelection(startOfLineSelection.blockIndex, startOfLineSelection.itemIndex, startOfLineSelection.positionIndex, currentSelection.endBlockIndex, currentSelection.endItemIndex, currentSelection.endPositionIndex);
      }
    }
    this.get('composerState').backspace();
    this.updateDomAndSelection();
    return action;
  },
  selectAll(action) {
    this.syncCurrentBlock();
    this.get('uiSelection').selectAll(this.get('$editor'));
    this.syncCurrentBlock();
    return action;
  },
  navigation(action) {
    let newSelectedBlock;
    this.syncCurrentBlock();
    if (this.isCurrentBlockAnICBlock()) {
      if (action.direction === 'down' || action.direction === 'right') {
        newSelectedBlock = this.putCaretAtStartOfNextBlock();
      } else {
        newSelectedBlock = this.putCaretAtEndOfPreviousBlock();
      }
      action.preventDefault = true;
      if (newSelectedBlock) {
        this.setBlockSelection();
        this.updateDomAndSelection();
      }
    }
    return action;
  },
  shiftSelection(action) {
    this.syncCurrentBlock();
    return action;
  },
  delete(action) {
    if (this.get('composerState.selection.hasWidth') || this.isCurrentBlockAnICBlock() || this.get('uiSelection.domSelection').isAtEndOfNode()) {
      this.syncCurrentBlock();
      this.get('composerState').delete();
      this.updateDomAndSelection();
      action.preventDefault = true;
    }
    return action;
  },
  backspace(action) {
    if (this.get('composerState.selection.hasWidth') || this.isCurrentBlockAnICBlock() || this.get('uiSelection.domSelection').isAtStartOfNode()) {
      this.syncCurrentBlock();
      this.get('composerState').backspace();
      this.updateDomAndSelection();
      action.preventDefault = true;
    }
    return action;
  },
  typeover(action) {
    this.backspace(action);
    action.preventDefault = false;
    return action;
  },
  backspaceWord(action) {
    this.syncCurrentBlock();
    this.get('composerState').backspaceWord();
    this.updateDomAndSelection();
    return action;
  },
  deleteWord(action) {
    this.syncCurrentBlock();
    this.get('composerState').deleteWord();
    this.updateDomAndSelection();
    return action;
  },
  softEnter(action) {
    if (!this.get('config.singleBlock')) {
      this.clearBlockSelection();
      this.syncCurrentBlock();
      this.get('composerState').softReturn();
      this.updateDomAndSelection();
      this.scrollToSelection();
    }
    return action;
  },
  enter(action) {
    if (!this.get('isTypeAheadVisible') && !this.get('config.singleBlock')) {
      this.clearBlockSelection();
      this.syncCurrentBlock();
      this.get('composerState').return();
      this.updateDomAndSelection();
      this.scrollToSelection();
    }
    return action;
  },
  removeFocus(action) {
    if (!this.get('isTypeAheadVisible')) {
      this.syncCurrentBlock();
      this.get('$editor').blur();
      this.get('uiSelection').clearDomSelection();
    }
    return action;
  },
  tab(action) {
    this.syncCurrentBlock();
    this.get('uiSelection').clearDomSelection();
    return action;
  },
  pasteAction(action) {
    if (this.get('useOffscreenPaste')) {
      this.syncCurrentBlock();
      this.redirectPasteToOffscreenDiv();
    }
    return action;
  },
  toggleDebugOutlines(action) {
    this.syncCurrentBlock();
    this.toggleProperty('showDebugOutlines');
    return action;
  },
  throwDebugException(action) {
    this.syncCurrentBlock();
    this.sendError(new Error('Debug exception'));
    return action;
  }
});